import { useState } from 'react';
import Icon from '../AppIcon';
import Image from '../AppImage';
import LegalModal from './LegalModal';

interface FooterProps {
  className?: string;
}

const Footer = ({ className = '' }: FooterProps) => {
  const [modalContent, setModalContent] = useState<'privacy' | 'terms' | 'disclaimer' | null>(null);

  const currentYear = new Date().getFullYear();

  const handleLegalClick = (type: 'privacy' | 'terms' | 'disclaimer') => {
    setModalContent(type);
  };

  const closeModal = () => {
    setModalContent(null);
  };

  return (
    <>
      <footer className={`glass-effect border-t border-border ${className}`}>
        <div className="container mx-auto px-6 py-12">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
            <div className="space-y-4">
              <div className="flex items-center space-x-3">
                <Image 
                  src="/assets/images/Dhavaja_Logo_Text_White-1765121120872.png"
                  alt="Dhavaja Logo"
                  className="h-10 w-auto object-contain"
                />
              </div>
              <p className="text-muted-foreground text-sm leading-relaxed">
                Premier electronics R&D lab delivering field-ready prototypes for mission-critical applications.
              </p>
            </div>

            <div>
              <h3 className="text-foreground font-semibold mb-4">Quick Links</h3>
              <ul className="space-y-2">
                <li>
                  <a
                    href="#about"
                    className="text-muted-foreground hover:text-primary transition-colors duration-250 text-sm"
                  >
                    About Us
                  </a>
                </li>
                <li>
                  <a
                    href="#capabilities"
                    className="text-muted-foreground hover:text-primary transition-colors duration-250 text-sm"
                  >
                    Capabilities
                  </a>
                </li>
                <li>
                  <a
                    href="#industries"
                    className="text-muted-foreground hover:text-primary transition-colors duration-250 text-sm"
                  >
                    Industries
                  </a>
                </li>
                <li>
                  <a
                    href="#process"
                    className="text-muted-foreground hover:text-primary transition-colors duration-250 text-sm"
                  >
                    Our Process
                  </a>
                </li>
              </ul>
            </div>

            <div>
              <h3 className="text-foreground font-semibold mb-4">Contact</h3>
              <ul className="space-y-3">
                <li className="flex items-start space-x-2">
                  <Icon name="MapPin" size={16} className="text-primary mt-1 flex-shrink-0" />
                  <span className="text-muted-foreground text-sm">
                    Noida Tech Hub, India
                  </span>
                </li>
                <li className="flex items-start space-x-2">
                  <Icon name="Mail" size={16} className="text-primary mt-1 flex-shrink-0" />
                  <a
                    href="mailto:dhavajaresearch@gmail.com"
                    className="text-muted-foreground hover:text-primary transition-colors duration-250 text-sm"
                  >
                    dhavajaresearch@gmail.com
                  </a>
                </li>
              </ul>
            </div>

            <div>
              <h3 className="text-foreground font-semibold mb-4">Connect</h3>
              <div className="flex items-center space-x-3 mb-4">
                <a
                  href="https://www.linkedin.com/company/dhavaja"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="p-2 rounded-md text-muted-foreground hover:text-accent hover:bg-accent/10 transition-all duration-250"
                  aria-label="LinkedIn"
                >
                  <Icon name="Linkedin" size={20} />
                </a>
              </div>
              <p className="text-muted-foreground text-sm">
                Follow us for updates
              </p>
            </div>
          </div>

          <div className="pt-8 border-t border-border">
            <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
              <p className="text-muted-foreground text-sm">
                © {currentYear} Dhavaja Research and Innovation Labs (P) Ltd. All rights reserved.
              </p>
              <div className="flex items-center space-x-6">
                <button
                  onClick={() => handleLegalClick('privacy')}
                  className="text-muted-foreground hover:text-primary transition-colors duration-250 text-sm"
                >
                  Privacy Policy
                </button>
                <button
                  onClick={() => handleLegalClick('terms')}
                  className="text-muted-foreground hover:text-primary transition-colors duration-250 text-sm"
                >
                  Terms of Service
                </button>
                <button
                  onClick={() => handleLegalClick('disclaimer')}
                  className="text-muted-foreground hover:text-primary transition-colors duration-250 text-sm"
                >
                  Disclaimer
                </button>
              </div>
            </div>
          </div>
        </div>
      </footer>

      <LegalModal
        isOpen={modalContent !== null}
        onClose={closeModal}
        type={modalContent || 'privacy'}
      />
    </>
  );
};

export default Footer;